// Utilidades para detectar si estamos en una app nativa (Capacitor) o en navegador web.
// Cuando corremos como app nativa, usamos plugins nativos (Cámara, Geolocalización real).
// Si no, fallback a APIs del navegador.

let _isNative = null;

export const isNative = () => {
  if (_isNative !== null) return _isNative;
  try {
    // Capacitor expone window.Capacitor cuando corre en app nativa
    _isNative = !!(window.Capacitor?.isNativePlatform?.());
  } catch {
    _isNative = false;
  }
  return _isNative;
};

// Captura una foto. Devuelve un data URL. Funciona tanto nativo como en web.
// En web usamos el <input type=file capture=environment> pasado por el caller.
export async function capturePhoto() {
  if (!isNative()) return null; // el caller gestiona el input file en web
  try {
    const { Camera, CameraResultType, CameraSource } = await import("@capacitor/camera");
    const photo = await Camera.getPhoto({
      quality: 75,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Camera,
      saveToGallery: false,
    });
    return photo.dataUrl; // "data:image/jpeg;base64,..."
  } catch (e) {
    console.warn("Camera error", e);
    return null;
  }
}

// Obtiene la ubicación GPS sin bloquear nunca: si el móvil no responde en 6 s
// (permiso sin contestar, GPS apagado, plugin ausente) se sigue sin coordenadas.
export function getCurrentPosition() {
  return Promise.race([
    _getPosition().catch(() => ({})),
    new Promise((res) => setTimeout(() => res({}), 6000)),
  ]);
}

async function _getPosition() {
  if (isNative()) {
    try {
      const { Geolocation } = await import("@capacitor/geolocation");
      const p = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 10000 });
      return { lat: p.coords.latitude, lng: p.coords.longitude };
    } catch (e) {
      console.warn("Native geo error", e);
      return {};
    }
  }
  return new Promise((res) => {
    if (!navigator.geolocation) return res({});
    navigator.geolocation.getCurrentPosition(
      (p) => res({ lat: p.coords.latitude, lng: p.coords.longitude }),
      () => res({}),
      { timeout: 8000, enableHighAccuracy: true }
    );
  });
}
